import Polyglot from 'node-polyglot';
import { DEFAULT_LANGUAGE } from 'UTILS/constants';

export let polyglot;

const AVAILABLE_LANGUAGES = ['fr', 'en'];

export const changeLocale = (language, { shouldBubble = true } = {}) => {
  polyglot.locale(language);
  polyglot.clear();
  if (shouldBubble && typeof CustomEvent === 'function') {
    const languageChangeEvent = new CustomEvent('locale_change', { detail: language });
    document.dispatchEvent(languageChangeEvent);
  }
};

export const initializeLocale = ({ locale }) => {
  if (!AVAILABLE_LANGUAGES.includes(locale.toLowerCase())) {
    locale = DEFAULT_LANGUAGE;
  }
  if (polyglot) {
    return;
  }
  polyglot = new Polyglot();
  changeLocale(locale.toLowerCase());
};
